// extracted by mini-css-extract-plugin
export default {"ScrollBar":"style_ScrollBar__jlM4B"};